import { render, staticRenderFns } from "./devTablets.vue?vue&type=template&id=a07b02da&scoped=true"
import script from "./devTablets.vue?vue&type=script&lang=ts"
export * from "./devTablets.vue?vue&type=script&lang=ts"
import style0 from "./devTablets.vue?vue&type=style&index=0&id=a07b02da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07b02da",
  null
  
)

export default component.exports